function scrollMenu() {
    var offset = 0;
    var scrollBottom = document.body.scrollHeight - window.innerHeight - window.scrollY
    var topoMenu = $('.topo-menu');
    if ($('.topo-menu:visible').size()) {
        offset = topoMenu.outerHeight();

        if ($(window).scrollTop() >= offset) {
            $('main.main-content').css('padding-top', $('.js-menu-fixed-topo').outerHeight() + 1);
            $(".js-menu-fixed-topo:visible").addClass("fixed");
        } else {
            $(".js-menu-fixed-topo:visible").removeClass("fixed");
            $('main.main-content').css('padding-top', 0);
        }
    }
    if ($('.topo-menu-wrapper:visible').size() && scrollBottom >= 150) {
        if (topoMenu.size()) {
            offset = $('.topo-menu').outerHeight();
            if ($(window).scrollTop() >= offset / 4) {
                $('.topo-menu-wrapper').addClass('animation');
            } else {
                $('.topo-menu-wrapper').removeClass('animation');
            }
        } else {
            if ($(window).scrollTop() >= 100) {
                $('.topo-menu-wrapper').addClass('animation');
            } else {
                $('.topo-menu-wrapper').removeClass('animation');
            }
        }
    }
}

function init() {
    scrollMenu();
    $(window).scroll(function () {
        scrollMenu();
    });
    $(window).resize(function () {
        scrollMenu();
    });
}

module.exports = {
    init
}


// WEBPACK FOOTER //
// ./resources/assets/layout-novo/js/modulo/menu-topo.js